import { AuthState } from '@okta/okta-auth-js';

import { SwapEntries } from '../../services/backend/SwapEntries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useSwapEntries: () => SwapEntries<AuthState> = () => {
  return useBaseApiClient(SwapEntries);
};
